export enum ELandlordsUrl {
    PROPERTY_MANAGEMENT = 'property-management',
    STATUS = 'status',
    EXPORT = 'export',
    PM_EMAILS = 'pm-emails',
}